/// <reference no-default-lib="true"/>
/* eslint-disable */
export default function Montante({ montante }) {
  const valor = montante >= 1000
  ? (montante / 1000).toFixed(3) // ex: 10000 -> 10.000 #FF0000
  : montante?.toString(); 
  return <h1 className="tw-text-xl tw-font-medium" style={{color:montante ? '#7EBF41' : '', fontSize:15, fontWeight:'900'}}>{valor? `${valor}, 00kz` : '00 kz'}</h1>; 
}
